module.exports = __webpack_public_path__ + "img/undraw_medical_research.92213443.svg";